// export const RECEIPT_URL = "http://localhost:8001/weborders/generate_receipt";
// export const RECEIPT_URL =
//   "https://lusuku-prod-server.herokuapp.com/weborders/generate_receipt";
export const RECEIPT_URL = "https://lusuku.shop/weborders/generate_receipt";
export const RECEIPT_URL_DEV =
  "http://localhost:8001/weborders/generate_receipt";
